if (!customElements.get('pt-review-carousel')) {
  customElements.define('pt-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: this.controller.signal });
      this.track = this.querySelector('.pt-review-carousel__track');
      this.cards = [...this.querySelectorAll('.pt-review-carousel__slide')];
      this.position = this.querySelector('[data-position]');
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovering = false;
      this.reading = false;
      this.inView = false;
      this.querySelector('.pt-review-carousel__controls').hidden = this.cards.length < 2;
      this.closest('section').setAttribute('data-ready', '');
      this.render = () => {
        const width = this.cards[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const first = Math.round(this.track.scrollLeft / (width + gap));
        const count = Math.max(1, Math.round((this.track.clientWidth + gap) / (width + gap)));
        const end = Math.min(this.cards.length, first + count);
        this.position.textContent = (count === 1 ? first + 1 : (first + 1) + '–' + end) + ' / ' + this.cards.length;
        this.position.setAttribute('aria-live', this.paused ? 'polite' : 'off');
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
        this.querySelector('[data-toggle-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
        this.querySelector('[data-toggle-text]').textContent = this.paused ? this.dataset.play : this.dataset.pause;
      };
      this.schedule = () => {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovering && !this.reading && this.inView && !document.hidden && !this.motion.matches) {
          this.timer = setTimeout(() => { this.move(1); this.schedule(); }, 8000);
        }
      };
      this.move = direction => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const step = this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        let left = this.track.scrollLeft + direction * step;
        if (direction > 0 && this.track.scrollLeft >= max - 3) left = 0;
        if (direction < 0 && this.track.scrollLeft <= 3) left = max;
        this.track.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: this.motion.matches ? 'instant' : 'smooth' });
      };
      on(this.querySelector('[data-next]'), 'click', () => { this.paused = true; this.move(1); this.render(); this.schedule(); });
      on(this.querySelector('[data-previous]'), 'click', () => { this.paused = true; this.move(-1); this.render(); this.schedule(); });
      on(this.toggle, 'click', () => { this.paused = !this.paused; this.render(); this.schedule(); });
      on(this.track, 'mouseenter', () => { this.hovering = true; this.schedule(); });
      on(this.track, 'mouseleave', () => { this.hovering = false; this.schedule(); });
      on(this.track, 'focusin', () => { this.reading = true; this.schedule(); });
      on(this.track, 'focusout', event => { this.reading = this.track.contains(event.relatedTarget); this.schedule(); });
      on(this.track, 'pointerdown', event => { if (event.pointerType !== 'mouse') { this.paused = true; this.render(); this.schedule(); } });
      on(this.track, 'scroll', this.render, { passive: true });
      on(document, 'visibilitychange', this.schedule);
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.render(); this.schedule(); });
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: .35 });
      this.observer.observe(this);
      this.resize = new ResizeObserver(this.render);
      this.resize.observe(this.track);
      this.render();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.controller = null;
    }
  });
}

